import { Stack, Text } from "@chakra-ui/react";
import { SimpleList } from "@/components/list";

export const FAQS = [
  {
    title: "How does SD-WAN improve network performance?",
    content:
      "SD-WAN dynamically routes traffic based on real-time network conditions, ensuring optimized bandwidth utilization, reduced latency, and improved cloud application performance.",
  },
  {
    title: "What is the main advantage of SDN over traditional networking?",
    content:
      "SDN separates the control plane from the data plane, enabling centralized network management, automation, and programmability, making networks more agile, scalable, and cost-efficient.",
  },
  {
    title: "How does Wi-Fi 6 benefit enterprise wireless networks?",
    content: (
      <Stack>
        <Text>Wi-Fi 6 offers:</Text>
        <SimpleList
          points={[
            "Higher data speeds for modern applications.",
            "Lower latency for real-time communication and IoT devices.",
            "Increased capacity to support more simultaneous users.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "Can SDN and SD-WAN integrate with cloud services?",
    content:
      "Yes! SDN and SD-WAN solutions provide direct cloud connectivity, improving performance for SaaS applications, multi-cloud strategies, and hybrid deployments.",
  },
  {
    title: "How does cloud-managed networking improve IT efficiency?",
    content:
      "Cloud-managed networking provides centralized control, real-time monitoring, and AI-driven insights, reducing manual configuration efforts and improving network security.",
  },
  {
    title: "What industries benefit the most from SDN and SD-WAN?",
    content:
      "Industries such as finance, healthcare, manufacturing, education, and retail benefit from enhanced security, optimized traffic management, and scalable network automation.",
  },
  {
    title: "What security features are included in SD-WAN?",
    content: (
      <SimpleList
        points={[
          "End-to-end encryption for secure data transmission.",
          "Zero-trust access controls for user authentication.",
          "Integrated firewall and threat detection for proactive security.",
        ]}
      />
    ),
  },
  {
    title: "How does SDN improve network security?",
    content: (
      <SimpleList
        points={[
          "Centralized policy enforcement across the entire network.",
          "Dynamic segmentation to isolate threats and prevent lateral movement.",
          "Automated responses to network anomalies using AI-driven threat detection.",
        ]}
      />
    ),
  },
  {
    title: "What are the key differences between SD-WAN and traditional WAN?",
    content: (
      <SimpleList
        points={[
          "SD-WAN is software-defined, allowing for centralized control and intelligent traffic management, while traditional WAN relies on static, hardware-based configurations.",
          "SD-WAN enables direct cloud access, reducing latency, whereas traditional WAN routes traffic through centralized data centers, increasing congestion.",
          "Cost efficiency – SD-WAN reduces dependency on costly MPLS circuits by utilizing broadband, LTE, and other transport methods.",
        ]}
      />
    ),
  },
  {
    title: "Can SD-WAN be used for multi-cloud networking?",
    content: (
      <Stack>
        <Text>Yes! SD-WAN provides: </Text>
        <SimpleList
          points={[
            "Direct connectivity to multiple cloud providers (AWS, Azure, Google Cloud) for faster access.",
            "Optimized application performance through cloud-aware traffic routing.",
            "Improved security by enforcing encryption and access policies across cloud services.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "What factors should businesses consider when choosing an SD-WAN solution?",
    content: (
      <Stack>
        <Text>Businesses should evaluate: </Text>
        <SimpleList
          points={[
            "Scalability – Ability to handle increasing bandwidth demands.",
            "Security features – Integrated firewall, encryption, and zero-trust architecture.",
            "Cloud integration – Direct access to SaaS and cloud applications.",
            "Performance optimization – AI-driven traffic management and WAN acceleration.",
            "Ease of management – Cloud-based control with real-time monitoring.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "How does Wi-Fi 6 enhance wireless networking?",
    content: (
      <Stack>
        <Text>Wi-Fi 6 improves performance through: </Text>
        <SimpleList
          points={[
            "Higher speeds (up to 9.6 Gbps) for high-bandwidth applications.",
            "Better efficiency in dense environments (offices, stadiums, airports).",
            "Lower latency, making it ideal for IoT, AR/VR, and real-time collaboration.",
            "Improved security with WPA3 encryption to prevent cyber threats.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "Can SDN be used in 5G networks?",
    content: (
      <Stack>
        <Text>Yes, SDN is a critical component of 5G networks as it: </Text>
        <SimpleList
          points={[
            "Automates network slicing to deliver custom bandwidth and QoS per application.",
            "Enhances traffic routing for ultra-low latency applications like IoT and autonomous vehicles.",
            "Provides centralized management, allowing operators to scale and optimize 5G infrastructure dynamically.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "How does cloud-managed networking reduce operational costs?",
    content: (
      <SimpleList
        points={[
          "Eliminates expensive on-premises controllers, reducing hardware costs.",
          "Automates updates and security patches, minimizing manual IT workload.",
          "Optimizes bandwidth allocation, reducing unnecessary data usage expenses.",
          "Remote troubleshooting and monitoring, reducing on-site maintenance costs.",
        ]}
      />
    ),
  },
];
